// The "BibleRacers" logo lockup — two stacked words with a chunky cartoon
// sticker look (thick navy outline + solid navy extrude). Rendered as inline
// SVG <text> so the outline + extrude export crisply at any size.

interface Props {
  /** Rendered width in px. The SVG scales proportionally. */
  width?: number;
  /** Play the entrance "pop" once on mount. */
  animate?: boolean;
  className?: string;
}

export default function Wordmark({ width = 760, animate = false, className = "" }: Props) {
  return (
    <div
      className={`${animate ? "animate-pop" : ""} ${className}`}
      style={{ transform: animate ? undefined : "rotate(-3deg)" }}
    >
      <svg
        viewBox="0 0 840 300"
        width={width}
        height={(width * 300) / 840}
        style={{
          overflow: "visible",
          maxWidth: "100%",
          height: "auto",
          filter:
            "drop-shadow(0 11px 0 #14204d) drop-shadow(0 20px 16px rgba(0,0,0,.28))",
        }}
        role="img"
        aria-label="BibleRacers"
      >
        <text
          x="420"
          y="138"
          textAnchor="middle"
          fontFamily="'Luckiest Guy', cursive"
          fontStyle="italic"
          fontSize="136"
          fill="#ffd23f"
          stroke="#1c2a63"
          strokeWidth="16"
          strokeLinejoin="round"
          paintOrder="stroke"
        >
          Bible
        </text>
        <text
          x="420"
          y="250"
          textAnchor="middle"
          fontFamily="'Luckiest Guy', cursive"
          fontStyle="italic"
          fontSize="156"
          fill="#ff5a4d"
          stroke="#1c2a63"
          strokeWidth="17"
          strokeLinejoin="round"
          paintOrder="stroke"
        >
          Racers
        </text>
      </svg>
    </div>
  );
}
